import { RIG_NAME } from "src/utils/constants";
import { ITochiChickenEye } from "src/utils/types";

export const timeout = async (ms: number) => {
  await new Promise((resolve) => setTimeout(resolve, ms));
};

export const getEyeName = (name: ITochiChickenEye) => {
  switch (name) {
    case "Default":
      return `${RIG_NAME}Chicken_Eyes_Default`;
    case "Closed":
      return `${RIG_NAME}Chicken_Eyes_Closed`;
    case "Up":
      return `${RIG_NAME}Chicken_Eyes_Up`;
    case "Down":
      return `${RIG_NAME}Chicken_Eyes_Down`;
    case "Left":
      return `${RIG_NAME}Chicken_Eyes_Left`;
    case "Right":
      return `${RIG_NAME}Chicken_Eyes_Right`;
    case "Mad":
      return `${RIG_NAME}Chicken_Eyes_Mad`;
    case "Squeeze":
      return `${RIG_NAME}Chicken_Eyes_Squeeze`;
    case "Surprise":
      return `${RIG_NAME}Chicken_Eyes_Suprise`;
    case "Droopy":
      return `${RIG_NAME}Chicken_Eyes_Droopy`;
    case "Sparkle":
      return `${RIG_NAME}Chicken_Eyes_Sparkle`;
    case "UpClosed":
      return `${RIG_NAME}Chicken_Eyes_UpClosed`;
    default:
      return `${RIG_NAME}Chicken_Eyes_Default`;
  }
};

export const getHairName = (hair: number) => {
  switch (hair) {
    case 1:
      return `${RIG_NAME}Chicken_Hair1`;
    case 2:
      return `${RIG_NAME}Chicken_Hair2`;
    case 3:
      return `${RIG_NAME}Chicken_Hair3`;
    case 4:
      return `${RIG_NAME}Chicken_Hair4`;
    case 5:
      return `${RIG_NAME}Chicken_Hair5`;
    default:
      return `${RIG_NAME}Chicken_Hair1`;
  }
};
